import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    position: 'relative',
  },
  input: {
    width: '100%',
    marginBottom: theme.spacing(3),
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(2),
    },
  },
  dropdown: {
    position: 'absolute',
    backgroundColor: theme.palette.colors.white,
    width: '100%',
    top: 60,
    zIndex: 2,
    boxShadow: `inset 0px -1px 0px 0px ${theme.palette.colors.border}`,
  },
  item: {
    cursor: 'pointer',
    padding: 4,
  },
  active: {
    backgroundColor: theme.palette.colors.lightTeal,
    borderRadius: 4,
    overflow: 'hidden',
  },
  error: {
    color: theme.palette.colors.red,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/AddressSelect/useStyles.js